export var MEDIUM_WIDTH = 140;
export var MEDIUM_ICON_SIZE = 40;
export var MEDIUM_SPACING = 'xsmall';
export var LARGE_WIDTH = 215;
export var LARGE_ICON_SIZE = 45;
export var LARGE_SPACING = 'small';
//# sourceMappingURL=settings.js.map